module.exports = __webpack_public_path__ + "static/media/left-quotes-sign.2afbd806.png";